import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SupportDeskQuickLinkService } from '../../support.services';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { SignalRHelper } from '@shared/helpers/SignalRHelper';
import { SupportComponentBase } from '@app/support/component-base.component';
import { NgIf } from '@angular/common';
import { SupportDeskTicketBaseComponent } from '../ticket/support-desk-ticket.component';

@Component({
    selector: 'support-quicklink',
    templateUrl: './support-quicklink.component.html',
    animations: [appModuleAnimation()],
    host: { class: 'overflow-scroll' },
    imports: [NgIf, SupportDeskTicketBaseComponent],
})
export class SupportQuickLinkComponent extends SupportComponentBase implements OnInit {
    tenantId: number | undefined;
    ticketId: number;
    accessToken: string;

    ready = false;

    public constructor(
        injector: Injector,
        protected ticketService: SupportDeskQuickLinkService,
        activatedRoute: ActivatedRoute,
    ) {
        super(injector);

        this.accessToken = activatedRoute.snapshot.queryParams['token'];
        ticketService.accessToken = this.accessToken;

        const tenantId = activatedRoute.snapshot.params['tenantId'];
        this.tenantId = tenantId === 'null' ? undefined : parseInt(tenantId);
        this.ticketId = parseInt(activatedRoute.snapshot.params['ticketId']);
    }

    ngOnInit(): void {
        SignalRHelper.initSignalR(() => (this.ready = true));
    }
}
